export default function Reddit({ color }) {
  return (
    <svg width='40' height='40' viewBox='0 0 33.72 33.72'>
      <g transform='translate(-1703.812 -2418.28)'>
        <circle
          cx='16.86'
          cy='16.86'
          r='16.86'
          transform='translate(1703.812 2418.28)'
          fill='#0e77ef'
          className={color}
        />
        <g transform='translate(1592 2350)'>
          <g transform='translate(-14.043 -10.043)'>
            <path
              d='M49.619,37.137a2.248,2.248,0,0,0-3.8-1.614,11.169,11.169,0,0,0-6.007-1.908l1.029-4.807,3.343.715a1.612,1.612,0,1,0,.165-.77l-3.729-.789a.392.392,0,0,0-.294.055.356.356,0,0,0-.165.257l-1.139,5.357a11.136,11.136,0,0,0-6.1,1.908,2.248,2.248,0,0,0-3.8,1.614,2.233,2.233,0,0,0,1.323,2.036,4.034,4.034,0,0,0-.055.679c0,3.449,4.023,6.256,8.983,6.256s8.983-2.789,8.983-6.256a4.237,4.237,0,0,0-.055-.679,2.26,2.26,0,0,0,1.322-2.055Zm-15.394,1.6a1.6,1.6,0,1,1,1.6,1.6A1.6,1.6,0,0,1,34.225,38.733Zm8.946,4.238c-1.1,1.1-3.2,1.174-3.8,1.174-.625,0-2.719-.092-3.8-1.174a.415.415,0,1,1,.588-.587,5.012,5.012,0,0,0,3.215.936,4.978,4.978,0,0,0,3.215-.936.411.411,0,0,1,.588,0A.446.446,0,0,1,43.171,42.971Zm-.294-2.624a1.6,1.6,0,1,1,1.6-1.6A1.6,1.6,0,0,1,42.877,40.347Z'
              transform='translate(103 58)'
              fill='#fff'
            />
          </g>
        </g>
      </g>
      <style jsx>
        {`
          .UA {
            fill: rgb(255, 69, 9) !important;
          }
        `}
      </style>
    </svg>
  )
}
